import { createInterpolatedTranslationKey, Translate } from '@dreryk/react-common';
import {
   Notification,
   NotificationSize,
   NotificationType,
   ValidationErrorNotification,
} from '@dreryk/react-components';

import { getQuantityMaxValue, getTreatmentDaysCountMaxValue } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../../translations';

type ExtendedDosageFormNotificationsProps = {
   readonly stagesEmpty: boolean;
   readonly breakMisplaced: boolean;
   readonly zeroDoseCycle: boolean;
   readonly treatmentDaysCountExceeded: boolean;
   readonly exceededPackagesCount: number | undefined;
};

export const ExtendedDosageFormNotifications = (props: ExtendedDosageFormNotificationsProps): JSX.Element => {
   return (
      <>
         {props.treatmentDaysCountExceeded ? (
            <ValidationErrorNotification
               testId={'extendedDosageTreatmentDaysCountExceeded'}
               label={
                  <Translate>
                     {createInterpolatedTranslationKey(
                        prescriptionTranslationKeys.numericalDosage.treatmentDaysCountExceededWithoutAction,
                        { maxValue: String(getTreatmentDaysCountMaxValue({ issuedForYear: true })) }
                     )}
                  </Translate>
               }
            />
         ) : null}
         {props.stagesEmpty ? (
            <ValidationErrorNotification
               testId={'extendedDosageStagesEmpty'}
               label={<Translate>{prescriptionTranslationKeys.extendedDosage.stagesEmpty}</Translate>}
            />
         ) : null}
         {props.breakMisplaced ? (
            <Notification
               testId={'extendedDosageBreakMisplaced'}
               type={NotificationType.WARNING}
               size={NotificationSize.SMALLER}
               label={<Translate>{prescriptionTranslationKeys.extendedDosage.breakMisplaced}</Translate>}
            />
         ) : null}
         {props.zeroDoseCycle ? (
            <ValidationErrorNotification
               testId={'extendedDosageZeroDoseCycle'}
               label={<Translate>{prescriptionTranslationKeys.extendedDosage.zeroDoseCycle}</Translate>}
            />
         ) : null}
         {props.exceededPackagesCount === undefined ? null : (
            <ValidationErrorNotification
               testId={'extendedDosagePackagesCountExceeded'}
               label={
                  <Translate>
                     {createInterpolatedTranslationKey(
                        prescriptionTranslationKeys.extendedDosage.packagesCountExceededTotal,
                        {
                           packagesCount: String(props.exceededPackagesCount),
                           maxValue: String(getQuantityMaxValue()),
                        }
                     )}
                  </Translate>
               }
            />
         )}
      </>
   );
};
